<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="企业名称">
                <a-input v-model="queryParam.devtenantNameName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
                <template >
              <a-col :md="8" :sm="24">
                <a-form-item label="时间范围">
                  <a-range-picker
                    v-model="value"
                    format="YYYY-MM-DD"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onChange"
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <!-- <a-button type="primary" @click="$refs.vrForm.handleAdd()" v-hasPermi="['10b98637049fb72c3493a8f4b983d745c:0:c']">
            <a-icon type="plus" />新增
          </a-button> -->
        </template>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <vrForm
        ref="vrForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
         <span slot="shareLogoUrl" slot-scope="text, record">
          <div v-viewer v-if="record.shareLogoUrl">
            <img :src="$url + record.shareLogoUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span>
        <span slot="supplementMapUrl" slot-scope="text, record">
          <div v-viewer v-if="record.supplementMapUrl">
            <img :src="$url + record.supplementMapUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span>
        <span slot="coverImageUrl" slot-scope="text, record">
          <div v-viewer v-if="record.coverImageUrl">
            <img :src="$url + record.coverImageUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span>
         <span slot="logoUrl" slot-scope="text, record">
          <div v-viewer v-if="record.logoUrl">
            <img :src="$url + record.logoUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.vrForm.handleUpdate(record, undefined)" v-hasPermi="['10b98637049fb72c3493a8f4b983d745d:0:d']"> 修改 </a>
          <!-- <a-divider type="vertical" v-hasPermi="['abm-fix:dev:remove']" /> -->
          <!-- <a @click="handleDelete(record)" v-hasPermi="['abm-fix:dev:remove']"> 删除 </a> -->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj } from '@/api/VR/tenantPlan/index'
import vrForm from './moduls/vrForm'
import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'
import UploadAdd from '../../system/tenant/modules/uploadAdd.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'Post',
  components: {
    vrForm,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantFirmId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      value: [],
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        tenantFirmId: undefined,
        postName: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '企业名称',
          dataIndex: 'tenantName',
          width:'15%',
          align: 'center',
        },
           {
          title: '补地图',
          dataIndex: 'supplementMapUrl',
          scopedSlots: { customRender: 'supplementMapUrl' },
          key: 'supplementMapUrl',
        },
        {
          title: '分享图',
          dataIndex: 'shareLogoUrl',
          scopedSlots: { customRender: 'shareLogoUrl' },
        },
        {
          title: '启动页',
          dataIndex: 'coverImageUrl',
          scopedSlots: { customRender: 'coverImageUrl' },
          key: 'coverImageUrl',
        },
         {
          title: 'logo',
          dataIndex: 'logoUrl',
          scopedSlots: { customRender: 'logoUrl' },
          key: 'logoUrl',
        },
        // {
        //   title: '租户简称	',
        //   dataIndex: 'referredName',
        //   align: 'center',
        // },
        // {
        //   title: '租户编码		',
        //   dataIndex: 'code',
        //   align: 'center',
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    if (!this.isOperate) {
      this.columns.pop()
    }
    this.queryParam.tenantFirmId = this.tenantFirmId
    this.queryParam.tenantId = this.tenantId
    this.getList()
    if (!this.tenantFirmId) {
      this.getQi()
    }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    // type
    // 点击批量添加设备
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(3)
      })
    },
    // 查询企业品牌
    getQi() {
      const query = {
        pageNum: 1,
        pageSize: 999,
        type: 1,
        status: 0,
      }
      listTenant(query).then((res) => {
        console.log(res, '的点点滴滴')
        this.userList = res.data.records
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
      // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
      if (e.length) {
        this.queryParam.createBeginTime = moment(e[0]).format('YYYY-MM-DD') + ' ' + '00:00:00'
        this.queryParam.createEndTime = moment(e[1]).format('YYYY-MM-DD') + ' ' + '23:59:59'
      } else {
        this.queryParam.createBeginTime = ''
        this.queryParam.createEndTime = ''
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.value = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/dev/export',
            {
              ...that.queryParam,
            },
            `设备信息${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
